import rest from '../rest'
import wechat from '../wechat/index'
import url from '../common/url'
import store from '../vuex/store'
import cache from '@/common/cache'
import Cookies from 'js-cookie'

export async function setToken() {
  const fakeToken = url.getSearch()['access-token'] // 临时token
  if (fakeToken) {
    cache.setSessionData('access_token', fakeToken)
    const { code, data, message } = await rest.auth.getJwtToken()
    if (code === 0) {
      const realToken = (data || {})['access-token']
      if (!realToken) {
        return [false, message]
      }
      cache.setSessionData('access_token', realToken)
      return [true, '']
    }
  }
}

export async function getLoginInfo() {
  const now = Date.now()
  const search = ('?from=wx_' + now) + (window.location.hash || '#/cus_day')
  const chooseStoreNext = encodeURIComponent(search)
  const next = encodeURIComponent(search)
  const query = {
    next,
    choose_store_next: chooseStoreNext,
    api: true
  }
  const {
    data: {
      is_authenticated: isAuthenticated,
      is_login: isLogin,
      url
    }
  } = await rest.auth.isLogin(query)

  // is_authenticated 是已微信认证
  // is_login    已选门店
  return [isAuthenticated, isLogin, url]
}

export async function chooseStore(storeID) {
  const res = await rest.auth.chooseStore(storeID)()
  // 更新 token
  cache.setSessionData('access_token', res.data['access-token'])
  cache.setLocalStorageData('last_store_id', storeID.toString())
  // Cookies.set('last_store_id', storeID.toString())
}

export async function setInitData() {
  // 选完门店才是正常状态，访问接口才不会401
  const { store_config: storeConfig, stores_config: storesConfig } = await getStoreConfig()
  const { store_id: curStoreId, store_name: curStoreName } = storeConfig || {}
  const fromStoreId = url.getSearch()._from_store_id

  // 显示切换门店确认框
  if (fromStoreId && +fromStoreId !== +curStoreId) {
    //  设置 changeStoreName 名称
    const { store_name: fromStoreName } = storesConfig.find(item => +item.store_id === +fromStoreId) || {}
    store.commit('UPDATE_CUR_STORE_NAME', curStoreName)
    store.commit('UPDATE_CHANGE_STORE_NAME', fromStoreName)
    store.commit('UPDATE_FROM_STORE_ID', fromStoreId)
    store.commit('UPDATE_IS_SHOW_VIEW', false)
    store.commit('UPDATE_IS_SHOW_CHANGE_STORE', true)
    return
  }

  // 获取并设置用户信息
  setAuthConfig()

  // 设置微信 JS-SDK 配置
  // TODO：在切换门店的时候会注册失败
  await wechat.checkWXConfig().catch((err) => {
    console.log(err.message)
  })
  store.commit('UPDATE_IS_SHOW_VIEW', true)
  store.commit('UPDATE_IS_SHOW_CHANGE_STORE', false)
}

export async function getStoreConfig(params = {}) {
  if (store.state.customized && store.state.customized.store_config) {
    return store.state.customized
  }
  // 获取定制化信息
  const { data } = await rest.auth.getCustomized(params)
  store.commit('UPDATE_CUSTOMIZED', data)
  return data
}

function setAuthConfig() {
  const authResult = getAuth()
  store.commit('UPDATE_AUTH', authResult)
}

function getAuth () {
  const { authList, userName, isPendingConfirm, id } = store.state
  return new Promise((resolve, reject) => {
    if (authList.length > 0) {
      resolve({
        authList: authList,
        userName: userName,
        id: id,
        isPendingConfirm: isPendingConfirm
      })
    } else {
      rest.auth.getAuth().then(res => {
        if (res.code === 0) {
          resolve({
            authList: res.data.permissions,
            userName: res.data.name,
            id: res.data.id,
            isPendingConfirm: res.data.is_service_booking_add
          })
        } else {
          reject(new Error(`获取权限失败，原因${res.message}`))
        }
      })
    }
  })
}
